import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const DatabaseStackIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 30 30" fill="none" {...props}>
    <path
      d="M16.25 6.25C16.25 7.63071 13.172 8.75 9.375 8.75C5.57804 8.75 2.5 7.63071 2.5 6.25M16.25 6.25C16.25 4.86929 13.172 3.75 9.375 3.75C5.57804 3.75 2.5 4.86929 2.5 6.25M16.25 6.25V8.125M2.5 6.25V21.25C2.5 22.6307 5.57804 23.75 9.375 23.75M9.375 13.75C9.16432 13.75 8.95585 13.7466 8.75 13.7398C5.24594 13.625 2.5 12.5541 2.5 11.25M9.375 18.75C5.57804 18.75 2.5 17.6307 2.5 16.25M26.5 13.375C26.5 14.7557 23.422 15.875 19.625 15.875C15.828 15.875 12.75 14.7557 12.75 13.375M26.5 13.375C26.5 11.9943 23.422 10.875 19.625 10.875C15.828 10.875 12.75 11.9943 12.75 13.375M26.5 13.375V22.75C26.5 24.1307 23.422 25.25 19.625 25.25C15.828 25.25 12.75 24.1307 12.75 22.75V13.375M26.5 18.0625C26.5 19.4432 23.422 20.5625 19.625 20.5625C15.828 20.5625 12.75 19.4432 12.75 18.0625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
